import { MouseEventHandler } from "react";
import { GButton } from "../GButton";
import styles from "./ExploreMoreButton.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";


interface ExploreMoreButtonProps {
    label: string,
    dataTestId: string,
    clickHandler?: MouseEventHandler,
    isDisabled?: boolean 
}

export const ExploreMoreButton = ({label, dataTestId, clickHandler, isDisabled}: ExploreMoreButtonProps) => {
    return (
        isDisabled ?
        <Tooltip title="Will be implemented soon">
            <GButton
                style={{cursor: "not-allowed"}}
                className={styles.button}
                variant="outlined"
                data-testid={dataTestId}
                endIcon={<FontAwesomeIcon icon={faCaretRight} size="sm" className={styles.arrowIcon}/>}
            >
                {label}
            </GButton>
        </Tooltip>
        :
        <GButton
            className={styles.button}
            variant="outlined"
            data-testid={dataTestId}
            onClick={clickHandler}
            endIcon={<FontAwesomeIcon icon={faCaretRight} size="sm" className={styles.arrowIcon}/>}
        >
        {label}
        </GButton>
    );
}